// extracted by mini-css-extract-plugin
module.exports = {"emailTabMinimized":"az_ZTb","emailTabMinimizedContent":"az__Tb","promoToggle":"az_aUb","promoText":"az_bUb","chevronIcon":"az_cUb","rotateToggle":"az_dUb"};